import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/styles/Popularpropertyspecs.css";
import analyticsService from "../../services/analyticsService";

import LeftNav from "../components/common/LeftNav";
import TopNav from "../components/common/TopNav";

import BookingIcon from "../assets/img/Booklead.svg";
import Searchh from "../assets/img/Searchh.svg";
import SFT from "../assets/img/sfticon.svg";
import LeadIcon from "../assets/img/registerlead.svg";
import homeadmin from "../assets/img/homeadmin.svg";
import arrowleftt from "../assets/img/arrowleftt.svg";

export default function PopularPropertySpecs() {
  const navigate = useNavigate();
  // EXACT React Native app state structure
  const [loading, setLoading] = useState(true);
  const [specs, setSpecs] = useState([]);
  const [states, setStates] = useState([]);
  const [citiesByState, setCitiesByState] = useState({});
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);

  // Load states and cities on component mount
  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setLoading(true);

      // Load states and cities first
      const citiesStatesResponse = await analyticsService.getCitiesAndStates();
      if (citiesStatesResponse.success && citiesStatesResponse.data) {
        setStates([...new Set((citiesStatesResponse.data.states || []).map(s => s.replace(/\s+\d{5,6}\s*$/, '').trim()))].sort());
        setCitiesByState(citiesStatesResponse.data.citiesByState || {});
      }

      await loadSpecs();
    } catch (error) {
      console.error('Error loading initial data:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadSpecs = async (pageNum = 1) => {
    try {
      const filters = { page: pageNum, per_page: 20 };
      if (selectedCity) filters.city = selectedCity;
      if (selectedState) filters.state = selectedState;

      const response = await analyticsService.getPopularSpecs(filters);

      if (response.success && response.data) {
        setSpecs(response.data.items || []);
        setTotal(response.data.total || 0);
        setTotalPages(response.data.total_pages || 1);
        setPage(pageNum);
      } else {
        setSpecs([]);
        setTotal(0);
        setTotalPages(1);
      }
    } catch (error) {
      console.error('Error loading specs:', error);
      setSpecs([]);
      setTotal(0);
      setTotalPages(1);
    }
  };

  const handleApply = async () => {
    setLoading(true);
    setPage(1); // Reset to first page when applying filters
    await loadSpecs(1);
    setLoading(false);
  };

  const handleStateChange = (e) => { setSelectedState(e.target.value); setSelectedCity(''); };
  const handleCityChange = (e) => { setSelectedCity(e.target.value); };
  const getFilteredCities = () => !selectedState ? [] : (citiesByState[selectedState] || []);

  // Format BHK spec (matches React Native app)
  const formatSpecName = (spec) => {
    return spec.bhk_type || `${spec.bedrooms} BHK` || 'Unknown Spec';
  };

  return (
    <div className="pps-page d-flex">
      <LeftNav />

      <div className="pps-content-wrap flex-grow-1">
        <TopNav />

        <div className="container-fluid">
          <div className="pps-card card pps-container-card mt-3">
            <div className="card-body">
              {/* Header */}
              <div className="d-flex justify-content-between align-items-start pps-header-row">
                <div className="d-flex align-items-center gap-2 pps-header-left">
                 <img src={arrowleftt} onClick={() => navigate("/webadmindashboard")} style={{cursor: "pointer"}}></img>
                  <h2 className="pps-page-title mb-0">Popular Property Specs</h2>
                </div>

                <div className="d-flex gap-2 align-items-end pps-filters">
                  <div className="d-flex flex-column">
                    <label className="pps-label">State</label>
                    <select
                      className="form-select form-select-sm pps-select"
                      value={selectedState}
                      onChange={handleStateChange}
                      disabled={loading}
                    >
                      <option value="">Select State</option>
                      {Array.isArray(states) ? states.map((state, idx) => (
                        <option key={idx} value={state}>{state}</option>
                      )) : []}
                    </select>
                  </div>

                  {selectedState && (
                    <div className="d-flex flex-column">
                      <label className="pps-label">City</label>
                      <select
                        className="form-select form-select-sm pps-select"
                        value={selectedCity}
                        onChange={handleCityChange}
                        disabled={loading}
                      >
                        <option value="">Select City</option>
                        {getFilteredCities().map((city, idx) => (
                          <option key={idx} value={city}>{city}</option>
                        ))}
                      </select>
                    </div>
                  )}

                  <button
                    className="btn btn-primary pps-apply-btn"
                    onClick={handleApply}
                    disabled={loading}
                  >
                    {loading ? 'Loading...' : 'Apply'}
                  </button>
                </div>
              </div>

              {/* Loading State */}
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <div className="mt-3" style={{ color: '#888' }}>Loading...</div>
                </div>
              ) : specs.length === 0 ? (
                <div className="pps-empty-container">
                  <p>No property specs found</p>
                  <button onClick={handleApply} className="pps-retry-btn">Retry</button>
                </div>
              ) : (
                <>
                  {/* Cards grid */}
                  <div className="pps-grid mt-3">
                    {specs.map((spec, idx) => {
                      const specName = formatSpecName(spec);
                      const rank = (page - 1) * 20 + idx + 1;

                      return (
                        <div key={`${spec.bedrooms || spec.bhk_type}-${idx}`} className="pps-item-card card">
                          <div className="card-body pps-item-body">
                            <div className="d-flex">
                              <div className="pps-main flex-grow-1">
                                <div className="d-flex justify-content-between align-items-start">
                                  <div className="pps-title d-flex align-items-center">
                                    <span className="pps-type">{rank} Property Spec:</span>
                                    <span className="pps-type-name ms-1">{specName}</span>
                                    <img src={homeadmin} alt={specName} className="pps-type-icon ms-2" />
                                  </div>
                                </div>

                                <div className="pps-borderline"></div>

                                {/* 2x2 grid */}
                                <ul className="pps-meta-grid list-unstyled mb-0">
                                  <li className="pps-meta-cell">
                                    <div className="pps-meta-left">
                                      <img src={BookingIcon} alt="Bookings" className="pps-meta-icon" />
                                      <span className="pps-meta-text">Total Bookings:</span>
                                    </div>
                                    <div className="pps-meta-right">
                                      <span className="pps-meta-value">{spec.total_bookings || 0}</span>
                                    </div>
                                  </li>

                                  <li className="pps-meta-cell">
                                    <div className="pps-meta-left">
                                      <img src={Searchh} alt="Searches" className="pps-meta-icon" />
                                      <span className="pps-meta-text">Searches:</span>
                                    </div>
                                    <div className="pps-meta-right">
                                      <span className="pps-meta-value">{spec.searches || 0}</span>
                                    </div>
                                  </li>

                                  <li className="pps-meta-cell">
                                    <div className="pps-meta-left">
                                      <img src={SFT} alt="Range" className="pps-meta-icon" />
                                      <span className="pps-meta-text">SFT Range:</span>
                                    </div>
                                    <div className="pps-meta-right">
                                      <span className="pps-meta-value">{spec.sft_range || '0 - 0 SFT'}</span>
                                    </div>
                                  </li>

                                  <li className="pps-meta-cell">
                                    <div className="pps-meta-left">
                                      <img src={LeadIcon} alt="Leads" className="pps-meta-icon" />
                                      <span className="pps-meta-text">Registered Leads:</span>
                                    </div>
                                    <div className="pps-meta-right">
                                      <span className="pps-meta-value">{spec.registered_leads || 0}</span>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {/* Pagination (EXACT React Native app logic) */}
                  {totalPages > 1 && (
                    <div className="pps-pagination">
                      <button
                        className={`pps-page-btn ${page <= 1 ? 'disabled' : ''}`}
                        onClick={async () => {
                          if (page > 1 && !loading) {
                            setLoading(true);
                            try {
                              await loadSpecs(page - 1);
                            } finally {
                              setLoading(false);
                            }
                          }
                        }}
                        disabled={page <= 1 || loading}
                      >
                        ← Previous
                      </button>

                      <span className="pps-page-info">
                        Page {page} of {totalPages} ({total} total)
                      </span>

                      <button
                        className={`pps-page-btn ${page >= totalPages ? 'disabled' : ''}`}
                        onClick={async () => {
                          if (page < totalPages && !loading) {
                            setLoading(true);
                            try {
                              await loadSpecs(page + 1);
                            } finally {
                              setLoading(false);
                            }
                          }
                        }}
                        disabled={page >= totalPages || loading}
                      >
                        Next →
                      </button>
                    </div>
                  )}
                </>
              )}

            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
